import { observable } from 'mobx'
import { Model } from 'libx'

/**
 * Document type.
 */
export default class DocumentType extends Model {
  @observable id
  @observable shortId
  @observable name
  @observable uploaderUserType
  @observable documentTypeId

  parse(json) {
    return {
      id: json.id,
      shortId: json.short_id,
      name: json.name,
      uploaderUserType: json.uploader_user_type,
    }
  }
}
